import React from 'react';
import { TrendingDown, TrendingUp } from 'lucide-react';
import styles from './PerformanceCard.module.scss';

/**
 * @param {'Clicks' | 'Cost'} type — label shown in the trend chip (reference design)
 */
export function PerformanceCard({ title, description, type = 'Clicks', isPositive = true }) {
  return (
    <div className={styles.card}>
      <div>
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.description}>{description}</p>
      </div>
      <div
        className={`${styles.badge} ${isPositive ? styles.badgePositive : styles.badgeNegative}`}
      >
        {isPositive ? <TrendingUp size={10} strokeWidth={3} aria-hidden /> : <TrendingDown size={10} strokeWidth={3} aria-hidden />}
        {type}
      </div>
    </div>
  );
}
